import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PruHttpService } from '../services/pru-http.service';
import { ContributionMessagesComponent } from './contribution-messages-component/contribution-messages.component';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    PruHttpService
  ],
  declarations: [
    ContributionMessagesComponent
  ],
  exports: [
    ContributionMessagesComponent
  ]
})
export class ContibutionMessagesModule {
  constructor() { }
}
